import { t } from '@framework/i18n';
import { TagProps } from 'antd';
import * as React from 'react';
import { DefaultTheme, useTheme } from 'styled-components';
import { EnumCodStatoPagamento } from './EnumCodStatoPagamento';
import { StyledTag } from './StyledTag';

/**
 * Ritorna le impostazioni per il tag
 */
function getTagOptions(
  state: EnumCodStatoPagamento | undefined,
  theme?: DefaultTheme,
): TagProps {
  if (!state) return { color: '#a5c201', children: 'N/D' };
  switch (state) {
    case EnumCodStatoPagamento.FALLIMENTO:
      return {
        color: theme?.colorError ?? '#fe0000',
        children: t(
          'payment-state-tag.errore-pagamento',
          'ERRORE PAGAMENTO',
        ),
      };
    case EnumCodStatoPagamento.SUCCESSO:
      return {
        color: theme?.colorSuccess ?? '#389e0d',
        children: t('payment-state-tag.completato', 'COMPLETATO'),
      };
    case EnumCodStatoPagamento.PENDENTE:
      return {
        color: '#9E6C00', // theme?.colorWarning ?? '#faad14',
        children: t('payment-state-tag.pendente', 'PENDENTE'),
      };
    case EnumCodStatoPagamento.DA_PAGARE:
      return {
        color: theme?.colorError ?? '#fe0000',
        children: t('payment-state-tag.da-pagare', 'DA PAGARE'),
      };
    default:
      return {
        color: theme?.colorInfo ?? '#569bc4',
        children: state,
      };
  }
}

export interface PaymentStateTagProps {
  state?: EnumCodStatoPagamento;
  mini?: boolean;
}

/**
 * Stato dei Pagamenti di un Onere
 */
export function PaymentStateTag(props: PaymentStateTagProps) {
  const { state, mini } = props;
  const theme = useTheme();

  if (!state) return null;

  return <StyledTag $mini={mini} {...getTagOptions(state, theme)} />;
}
